import { useEffect, useState } from 'react'
import Navbar from '../../components/navbar/navbar.jsx'
import CryptoJS from 'crypto-js'
import api from '../../services/api.js'
import 'bootstrap/dist/css/bootstrap.css'
import { v4 as uuidv4 } from 'uuid'
import apinode from '../../services/apinode.js'
import React, { useRef } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { Modal, Button, Form, Table } from 'react-bootstrap'
import { format, getUnixTime } from 'date-fns'
import { Link, useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import moment from 'moment'
import InputMask from 'react-input-mask'
import AutocompleteCliente from '../../components/autocomplete-cliente/autocomplete-cliente.jsx'
import AutocompleteProdutoMatch from '../../components/auto-complete-match-produto/complete-match.jsx'
import './nfeentrada.css'
import EditModal from '../../components/nfeentrada/editmodal.jsx'
import SidebarModal from '../../components/nfeentrada/sidebar.jsx'
import { CheckCircle, XCircle } from 'react-bootstrap-icons'
import CancelButton from '../../components/nfeentrada/cancelbutton.jsx'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { adaptValue } from '../../utils/adaptValue.js'
import Draggable from 'react-draggable'
import {
  CheckCircleFill,
  XCircleFill,
  ArrowBarRight,
} from 'react-bootstrap-icons'
import { BsArrowUp, BsArrowDown } from 'react-icons/bs'
import { FaSave } from 'react-icons/fa'
import { ConeStriped } from 'react-bootstrap-icons/dist/index.js'

function NfeEntrada() {
  const [id, setId] = useState('')
  const [numNfe, setNumNfe] = useState('')
  const [serieNfe, setSerieNfe] = useState('')
  const [dataEmissao, setDataEmissao] = useState('')
  const [dataEntrada, setDataEntrada] = useState('')
  const [total, setTotal] = useState('')
  const [acrescimo, setAcrescimo] = useState('')
  const [desconto, setDesconto] = useState('')
  const [frete, setFrete] = useState('')
  const [icmsFrete, setIcmsFrete] = useState('')
  const [tipoEntrada, setTipoEntrada] = useState('')
  const [vlrBaseIcmsSt, setVlrBaseIcmsSt] = useState('')
  const [vlrIcmsSt, setVlrIcmsSt] = useState('')
  const [totalProdutos, setTotalProdutos] = useState('')
  const [codificacaoFiscal, setCodificacaoFiscal] = useState('')
  const [emissorCodigoEstado, setEmissorCodigoEstado] = useState('')
  const [chaveNfe, setChaveNfe] = useState('')
  const [bcIcms, setBcIcms] = useState('')
  const [valorIcms, setValorIcms] = useState('')
  const [valorPis, setValorPis] = useState('')
  const [valorCofins, setValorCofins] = useState('')
  const [valorIpi, setValorIpi] = useState('')
  const [valorSeguro, setValorSeguro] = useState('')
  const [freteIncluso, setFreteIncluso] = useState('')
  const [valorIcmsSubIncluso, setValorIcmsSubIncluso] = useState('')
  const [custoSemDesconto, setCustoSemDesconto] = useState('')
  const [fornecedorRazao, setFornecedorRazao] = useState('')
  const [fornecedorEndereco, setFornecedorEndereco] = useState('')
  const [fornecedorBairro, setFornecedorBairro] = useState('')
  const [fornecedorCidade, setFornecedorCidade] = useState('')
  const [fornecedorCep, setFornecedorCep] = useState('')
  const [fornecedorUf, setFornecedorUf] = useState('')
  const [fornecedorCnpj, setFornecedorCnpj] = useState('')
  const [fornecedorInsc, setFornecedorInsc] = useState('')
  const [fornecedorTel, setFornecedorTel] = useState('')
  const [fornecedorNumero, setFornecedorNumero] = useState('')
  const [fornecedorIbge, setFornecedorIbge] = useState('')
  const [fornecedorTipo, setFornecedorTipo] = useState('')
  const [transportadoraNome, setTransportadoraNome] = useState('')
  const [transportadoraEndereco, setTransportadoraEndereco] = useState('')
  const [transportadoraCidade, setTransportadoraCidade] = useState('')
  const [transportadoraUf, setTransportadoraUf] = useState('')
  const [transportadoraCnpj, setTransportadoraCnpj] = useState('')
  const [transportadoraInsc, setTransportadoraInsc] = useState('')
  const [transportadoraPlaca, setTransportadoraPlaca] = useState('')
  const [transportadoraUfPlaca, setTransportadoraUfPlaca] = useState('')
  const [transportadoraTipo, setTransportadoraTipo] = useState('')
  const [status, setStatus] = useState('')
  const [entradaTipo, setEntradaTipo] = useState('')
  const [naturezaOperacao, setNaturezaOperacao] = useState('')
  const [codigoRegimeTributario, setCodigoRegimeTributario] = useState('')
  const [finalidade, setFinalidade] = useState('')
  const { id_conta } = useParams()
  const [clickInProgress, setClickInProgress] = useState(false)
  const [checkboxChecked, setCheckboxChecked] = useState(false)
  const [clickvalor, setClickValor] = useState('')

  const [id_cliente, setIdCliente] = useState(0)
  const [nome_cliente, setNomeCliente] = useState('')
  const [produtos, setProdutos] = useState([])
  const { nota } = useParams()
  const [duplicatas, setDuplicatas] = useState([])
  const [datavencimento, setDataVencimento] = useState()
  const [quantidade, setQuantidade] = useState('')
  const [pesoBruto, setPesoBruto] = useState('')
  const [pesoLiquido, setPesoLiquido] = useState('')
  const [numeracao, setNumeracao] = useState('')
  const [especie, setEspecie] = useState('')
  const [marca, setMarca] = useState('')
  const now = moment()
  const [showModal, setShowModal] = useState(false)
  const [formData, setFormData] = useState({})
  const [textoClick, setTextoClick] = useState('')

  const [showModalMatch, setShowModalMatch] = useState(false)
  const [produtoNota, setProdutoNota] = useState('')
  const [produtoBanco, setProdutoBanco] = useState('')
  const [matchResultado, setMatchResultado] = useState(null)
  const [matchproduto, setMatchProduto] = useState('')
  const [codinterno, setCodigoInterno] = useState('')
  const [IdprodutoMatch, setIdProdutoMatch] = useState(0)
  const [desc_prodM, setDescProdMatch] = useState('')
  const [ret, setRetApi] = useState([])
  const [dataC, setDatac] = useState('')
  const [descprodutonota, setDescProdutoNota] = useState('')
  const [outrasdespesas, setOutrasDespesas] = useState('')
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [itemToDelete, setItemToDelete] = useState(null)
  const [idItemExclusao, setIdItemExclusao] = useState(null)
  const [calcularImpostos, setCalcularImpostos] = useState(false)
  const [addCont, setAddCont] = useState('N')
  const [calcImp, setCalcImp] = useState('N')
  const [isLoading, setIsLoading] = useState(false)
  const [observacoes, setObservacoes] = useState({})

  const [valorIcmsSt, setValorIcmsSt] = useState(0)
  const [valorIpiParsed, setValorIpiParsed] = useState(0)
  const [outrasDespesasComImpostos, setOutrasDespesasComImpostos] = useState(0)
  const [showPopup, setShowPopup] = useState(false)

  const handleClose = () => {
    const confirmation = window.confirm(
      'Tem certeza de que deseja fechar a aba?',
    )
    if (confirmation) {
      window.close()
    }
  }

  const updateArray = (event, index) => {
    const newValue = event.target.value

    setDuplicatas((prevDuplicatas) => {
      const updatedDuplicatas = [...prevDuplicatas]
      updatedDuplicatas[index] = { ...updatedDuplicatas[index], OBS: newValue }
      console.log(updatedDuplicatas)
      return updatedDuplicatas
    })
  }

  function removerCaracteresNaoNumericos(valor) {
    return valor.replace(/[^0-9.-]+/g, '')
  }

  const excluirDuplicata = (idItem) => {
    // Exibir o modal de confirmação de exclusão
    setIdItemExclusao(idItem)
    setShowConfirmation(true)
  }

  function calcularCustos() {
    const itensAtualizados = [];

    const novosProdutos = produtos.map(item => {
      const custoItem = (item.VALORICMSST + item.VALORIPI) / item.QUANTIDADE + item.VALOR;
      if (item.CUSTO !== custoItem) {
        itensAtualizados.push({ codigo: item.CODIGOPRODUTO, novoCusto: custoItem });
        return { ...item, CUSTO: custoItem };
      } else {
        return item;
      }
    });

    setProdutos(novosProdutos);

    let alertMessage = "Custos calculados e atualizados com sucesso!\nItens atualizados:\n";
    itensAtualizados.forEach(item => {
      alertMessage += `Código: ${item.codigo}, Novo Custo: ${item.novoCusto.toFixed(2)}\n`;
    });

    alert(alertMessage);
  }





  const confirmarExclusaoDuplicata = () => {
    // Verificar se o idItemExclusao é válido
    if (idItemExclusao) {
      // Filtrar a lista de duplicatas, removendo o item com o id correspondente
      const novaListaDuplicatas = duplicatas.filter(
        (dupli) => dupli.ID !== idItemExclusao,
      )

      // Atualizar a lista de duplicatas
      setDuplicatas(novaListaDuplicatas)
    }

    // Fechar o modal de confirmação
    setShowConfirmation(false)
  }

  const handleObsDupliChange = (value, index) => {
    const updatedDuplicatas = [...duplicatas]
    updatedDuplicatas[index].obs = value
    setDuplicatas(updatedDuplicatas)
  }

  const handleValorChange = (value, index) => {
    const updatedDuplicatas = [...duplicatas]
    updatedDuplicatas[index].VALOR = parseFloat(value)
    setDuplicatas(updatedDuplicatas)
  }

  const handleVencimentoChange = (value, index) => {
    const updatedDuplicatas = [...duplicatas] // Faça uma cópia do array de duplicatas
    const vencimento = moment(value) // Converta o valor para uma instância do Moment.js

    // Verifique se a data é válida antes de atualizar o valor
    if (vencimento.isValid()) {
      updatedDuplicatas[index].VENCIMENTO = vencimento.format('YYYY-MM-DD')
      setDuplicatas(updatedDuplicatas)
    }
  }

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked

    // Atualiza o estado do checkbox
    setCheckboxChecked(isChecked)

    // Realiza as atualizações dos valores
    if (isChecked) {
      // Lógica para atualizar os valores quando o checkbox está marcado
      const novoValorIcmsSt = parseFloat(
        vlrIcmsSt
          .replace(/[^0-9,-]/g, '')
          .replace(',', '.')
          .trim(),
      )
      const novoValorIpiParsed =
        parseFloat(
          valorIpi
            .replace(/[^0-9,-]/g, '')
            .replace(',', '.')
            .trim(),
        ) || 0
      const novoValorImpostos = novoValorIcmsSt + novoValorIpiParsed
      const novoOutrasDespesasComImpostos =
        parseFloat(
          outrasdespesas
            ?.replace?.(/[^0-9,-]/g, '')
            .replace(',', '.')
            .trim() ?? 0,
        ) + novoValorImpostos

      // setValorIcmsSt(novoValorIcmsSt);
      // setValorIpiParsed(novoValorIpiParsed);
      setOutrasDespesas(novoOutrasDespesasComImpostos)
    } else {
      // Lógica para atualizar os valores quando o checkbox não está marcado
      // setValorIcmsSt(0);
      // setValorIpiParsed(0);
      setOutrasDespesasComImpostos(
        parseFloat(
          outrasdespesas
            ?.replace?.(/[^0-9,-]/g, '')
            .replace(',', '.')
            .trim() ?? 0,
        ),
      )
    }
  }

  // const calcularCusto = () => {
  //     const valorTotal = parseFloat(outrasdespesas);

  //     const produtosAtualizados = produtos.map(item => {
  //         const valorCusto = parseFloat(item.valor) * parseFloat(item.quantidade) + valorTotal;
  //         const novoCusto = valorCusto / parseFloat(item.quantidade);
  //         return {
  //             ...item,
  //             custo: novoCusto
  //         };
  //     });

  //     setProdutos(produtosAtualizados);
  //     console.log(produtos)
  // };

  // const calcularCusto = () => {
  //     const valorTotal = parseFloat(outrasdespesas);

  //     const produtosAtualizados = produtos.map(item => {
  //         let valorCusto = parseFloat(item.valor) * parseFloat(item.quantidade) + valorTotal;

  //         if (calcularImpostos) {
  //             valorCusto += parseFloat(vlrIcmsSt.replace('R$', ''));
  //             valorCusto += parseFloat(valorIpi.replace('R$', ''));

  //         }

  //         const novoCusto = valorCusto / parseFloat(item.quantidade);

  //         debugger

  //         return {
  //             ...item,
  //             custo: novoCusto

  //         };

  //     });

  //     setProdutos(produtosAtualizados);
  //     //     console.log(produtos)

  // }

  // const calcularCusto = () => {
  //     const valorTotal = parseFloat(outrasdespesas);

  //     const totalQuantidade = produtos.reduce((acumulador, item) => acumulador + parseFloat(item.quantidade), 0);

  //     const produtosAtualizados = produtos.map(item => {
  //         let valorCusto = parseFloat(item.valor) * parseFloat(totalQuantidade) + valorTotal;

  //         if (calcularImpostos) {
  //             valorCusto += parseFloat(vlrIcmsSt.replace('R$', ''));
  //             valorCusto += parseFloat(valorIpi.replace('R$', ''));
  //         }

  //         const novoCusto = valorCusto / totalQuantidade;

  //         return {
  //             ...item,
  //             custo: novoCusto
  //         };
  //     });

  //     setProdutos(produtosAtualizados);
  // }

  const handleClosePopup = () => {
    setShowPopup(false)
  }

  const calcularCusto = (outrasDespesas) => {
    console.log({ calcularCusto: outrasDespesas })

    const valorAdicional = parseFloat(outrasDespesas)

    if (!produtos || !Array.isArray(produtos)) {
      console.error(
        'A variável "produtos" não foi definida corretamente ou não é um array',
      )
      return
    }

    // Remove todos os caracteres não numéricos do valor total
    const valorTotalNota = parseFloat(
      totalProdutos.replace('R$', '').replace('.', '').replace(',', '.'),
    )

    const totalN = parseFloat(
      total.replace('R$', '').replace('.', '').replace(',', '.'),
    )

  
    let totais = 0
    console.log(adaptValue(total), 'total nota')

   

    totais = adaptValue(total) 


   

    console.log(`totais`, totais, vlrIcmsSt, valorIpi)

    const porcentagemCusto = adaptValue((valorAdicional / totais) * 100)
    console.log(porcentagemCusto, valorAdicional)

    produtos.forEach((item) => {
      const valorUnitarioCusto = item.CUSTO || item.VALOR

      console.log('porc', porcentagemCusto, totais) // Resultado: 1.7301038062283737
      const valorAdicionalCusto = valorUnitarioCusto * (porcentagemCusto / 100)
      const precoCusto =
        parseFloat(valorUnitarioCusto) + parseFloat(valorAdicionalCusto)

      item.CUSTO = precoCusto
      console.log(porcentagemCusto)
    })

    setProdutos([...produtos])
  }

  async function SalvarDados() {
    setIsLoading(true)
    const dadosNfe = {
      idconta: id_conta,
      id: ret?.ID,
      idFornec: ret?.FORN_COD,
      outrasdespesas: outrasdespesas,
      duplicatas: duplicatas,
      addcont: addCont,
      calcimp: calcImp,
      itens: produtos,
    }

    console.log(dadosNfe)

    try {
      // Executa o salvamento dos dados somente se a função EnviarDuplicatas não lançar uma exceção
      const retorno = await apinode.put('/postnfeentrada', dadosNfe)

      if (retorno.status === 200) {
        swal('Sucesso', retorno.data, 'success')
        setIsLoading(false)
        console.log(retorno)
      } else {
        swal('Erro', retorno.data, 'warning')
        console.log(retorno)
        setIsLoading(false)
      }
    } catch (error) {
      console.log(error)
      alert(error)
      setIsLoading(false)
    }
  }

  async function EnviarDuplicatas() {
    const dados = {
      idconta: id_conta,
      idnfe: ret?.ID,
      idFornec: ret?.FORN_COD,
      idpedidocompra: null,
      duplicatas: duplicatas,
    }

    // Verifica se o checkbox está marcado
    const lancarContasCheckbox = document.getElementById('lancarContas')
    if (lancarContasCheckbox.checked) {
      // Executa a função apenas se o checkbox estiver marcado
      // Coloque aqui o código adicional que deseja executar

      // Resto do código da função EnviarDuplicatas()
      try {
        const retorno = await apinode.put('/addcontas', dados)

        if (retorno.status === 200) {
          // alert('Registro salvo com sucesso!');
        } else {
          alert('Erro ao gerar contas !')
          console.log(retorno)
        }
      } catch (error) {
        console.log(error)
      }
    } else {
      console.log('optou por nao lancar contas')
    }
  }
  const toggleModal = () => {
    setShowModal(!showModal)
  }

  function handleSubmit(event) {
    event.preventDefault()
    // envia os dados do volume para o servidor
  }

  const handleSave = (data) => {
    // Lógica de salvamento dos dados
    console.log(data)
  }

  function buscaCep() {
    const fornecedorCepInput = document.getElementById('fornecedorCep')
    const cep = fornecedorCepInput.value.replace(/\D/g, '')
    const url = `https://viacep.com.br/ws/${cep}/json/`
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.onload = function () {
      const response = JSON.parse(xhr.responseText)
      document.getElementById('fornecedorEndereco').value = response.logradouro
      document.getElementById('fornecedorBairro').value = response.bairro
      document.getElementById('fornecedorCidade').value = response.localidade
      document.getElementById('fornecedorUf').value = response.uf
      document.getElementById('fornecedorIbge').value = response.ibge
    }
    xhr.send()
  }

  function dataEnt(dataent) {
    const data = new Date(dataent)
    const dataFormatada = `${String(data.getDate()).padStart(2, '0')}/${String(
      data.getMonth() + 1,
    ).padStart(2, '0')}/${data.getFullYear()}`
    console.log(dataFormatada) // "2023-05-01"
    const originalDateStr = dataFormatada
    const originalDateFormat = 'DD/MM/YYYY'
    const targetDateFormat = 'YYYY-MM-DD'

    const formattedDateStr = moment(originalDateStr, originalDateFormat).format(
      targetDateFormat,
    )

    console.log(formattedDateStr) // Output: 2023-05-01

    setDataEntrada(formattedDateStr)
  }

  function dataVenc(datavenc) {
    const data = new Date(datavenc)
    const dataFormatada = `${String(data.getDate()).padStart(2, '0')}/${String(
      data.getMonth() + 1,
    ).padStart(2, '0')}/${data.getFullYear()}`
    console.log(dataFormatada) // "2023-05-01"
    const originalDateStr = dataFormatada
    const originalDateFormat = 'DD/MM/YYYY'
    const targetDateFormat = 'YYYY-MM-DD'

    const formattedDateStr = moment(originalDateStr, originalDateFormat).format(
      targetDateFormat,
    )

    setDataEntrada(formattedDateStr)
  }

  function dataEmiss(dataemiss) {
    const data = new Date(dataemiss)
    const dataFormatada = `${String(data.getDate()).padStart(2, '0')}/${String(
      data.getMonth() + 1,
    ).padStart(2, '0')}/${data.getFullYear()}`
    console.log(dataFormatada) // "2023-05-01"
    const originalDateStr = dataFormatada
    const originalDateFormat = 'DD/MM/YYYY'
    const targetDateFormat = 'YYYY-MM-DD'

    const formattedDateStr = moment(originalDateStr, originalDateFormat).format(
      targetDateFormat,
    )

    setDataEmissao(formattedDateStr)

    const date = new Date('2023-04-07')
    const unixTime = date.getTime()
    // console.log(unixTime); // Exemplo de saída: 1684080000000
  }

  function handleDescricaoChange(id_produto, descricao, index) {
    const prod = [...produtos]

    prod[index].id_produto = id_produto
    prod[index].descricao = descricao

    setProdutos(prod)
  }

  useEffect(() => {
    // reqToken();
    localStorage.setItem('id_conta', id_conta)
    listaItensNfe()

    if (addCont === 'S') {
      // Exibe o toast quando abrir o popup
      toast.info('As contas já foram lançadas.', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000, // Fecha automaticamente após 3 segundos
      });
    }
  }, [])

  function listaItensNfe() {
    console.log('token', localStorage.id_conta)
    apinode
      .get(
        '/itemnfeentrada',

        {
          params: {
            id: nota,
            conta: id_conta,
          },
        },
      )

      .then((retorno) => {
        console.log(retorno)
        if (retorno.status == 200) {
          setRetApi(retorno.data)

          setId(retorno.data.ID)
          setNumNfe(retorno.data.NUMNFE)
          setChaveNfe(retorno.data.CHAVENFE)
          setSerieNfe(retorno.data.SERIENFE)
          setDataEmissao(retorno.data.DATAEMISSAO)
          dataEnt(retorno.data.DATAENTRADA)
          dataEmiss(retorno.data.DATAEMISSAO)

          setFornecedorTipo(retorno.data.FORNEC_TIPO)
          setNomeCliente(retorno.data.FORNEC_RAZAO)
          setNaturezaOperacao(1)
          setCodigoRegimeTributario(1)
          setFinalidade(1)
          setFornecedorEndereco(retorno.data.FORNEC_ENDERECO)
          setFornecedorNumero(retorno.data.FORNEC_NUMERO)
          setFornecedorBairro(retorno.data.FORNEC_BAIRRO)
          setFornecedorCidade(retorno.data.FORNEC_CIDADE)
          setFornecedorUf(retorno.data.FORNEC_UF)
          setFornecedorCep(retorno.data.FORNEC_CEP)
          setFornecedorIbge(retorno.data.FORNEC_IBGE)
          setOutrasDespesas(retorno.data.OUTRASDESPESAS)
          setTotal(
            retorno.data.TOTAL.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setAcrescimo(
            retorno.data.ACRESCIMO.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setDesconto(
            retorno.data.DESCONTO.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setFrete(
            retorno.data.FRETE.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setIcmsFrete(
            retorno.data.ICMSFRETE.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setBcIcms(
            retorno.data.BCICMS.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setValorIcms(
            retorno.data.VALORICMS.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setVlrBaseIcmsSt(
            retorno.data.VLRBASEICMSST.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setVlrIcmsSt(
            retorno.data.VLRICMSST.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setTotalProdutos(
            retorno.data.TOTAL_PRODUTOS.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setEmissorCodigoEstado(retorno.data.EMISSOR_CODIGOESTADO)
          setCodificacaoFiscal(retorno.data.CODIFICACAOFISCAL)
          setValorPis(
            retorno.data.VALORPIS.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setValorCofins(
            retorno.data.VALORCOFINS.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setValorIpi(
            retorno.data.VALORIPI.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setValorSeguro(
            retorno.data.VALORSEGURO.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          setFreteIncluso(retorno.data.FRETEINCLUSO)
          setValorIcmsSubIncluso(retorno.data.VALORICMSSUBINCLUSO)
          setCustoSemDesconto(retorno.data.CUSTOSSEMDESCONTO)
          setProdutos(retorno.data.itens)
          setDuplicatas(retorno.data.duplicatas)
          setTransportadoraNome(retorno.data.TRANSP_NOME)
          setTransportadoraCnpj(retorno.data.TRANSP_CNPJ)
          setTransportadoraEndereco(retorno.data.TRANSP_ENDERECO)
          setTransportadoraInsc(retorno.data.TRANSP_INSC)
          setTransportadoraCidade(retorno.data.TRANSP_CIDADE)
          setTransportadoraPlaca(
            retorno.data.TRANSP_PLACA + ' - ' + retorno.data.TRANSP_UFPLACA,
          )
          setTransportadoraUf(retorno.data.TRANSP_UF)
          setTransportadoraTipo(retorno.data.TRANSP_TIPO)
          setPesoBruto(retorno.data.PESOTOTAL)
          setAddCont(retorno.data.ADDCONT)
          setCalcImp(retorno.data.CALCIMP)
        } else {
          alert('Erro ao processar... contate suporte!')
          console.log(retorno)
        }
      })
  }

  const reqToken = async () => {
    try {
      const response = await apinode.get('/emp', {
        params: {
          token: id_conta,
        },
      })

      if (response.status === 200) {
        const token = response.data.ID_CONTA
        console.log(token)

        if (Array.isArray(token) && token.length === 0) {
          // Sessão expirada
          swal(
            'Sessão expirada',
            'Por favor, feche e abra novamente.',
            'warning',
          )
        } else {
          localStorage.setItem('id_conta', token)
        }
      } else {
        console.log('Erro ao requisitar token')
      }
    } catch (error) {
      console.error(error)
    }
  }
  const handleMatchSubmit = () => {
    // Realize o processo de match entre o produto da nota de entrada (produtoNota) e o item do banco de dados (produtoBanco)
    // ...

    // Exemplo de como lidar com o resultado do match

    const resultado = {
      produto: produtoNota,
      itemBanco: IdprodutoMatch,
      match: true,
    }

    setMatchResultado(resultado)

    findAndUpdateObject(
      produtos,
      produtoNota,
      IdprodutoMatch,
      matchproduto,
      'S',
      codinterno,
    )
    console.log(codinterno)

    // Feche o modal após um breve intervalo
    setTimeout(() => {
      setShowModal(false)
    }, 2000)
  }

  const handleDragStart = (event, produto) => {
    event.dataTransfer.setData('text/plain', produto)
  }

  const handleDragOver = (event) => {
    event.preventDefault()
  }

  const handleDrop = (event) => {
    event.preventDefault()
    const produto = event.dataTransfer.getData('text/plain')
    setProdutoBanco(produto)
  }

  const limparCampo = (id) => {
    const campo = document.getElementById(id)
    if (campo) {
      campo.value = ''
    }
  }

  function findAndUpdateObject(
    array,
    ID,
    SKU_MATCH,
    DESC_MATCH,
    MATCH,
    CODPRODUTO_MATCH,
  ) {
    // Encontre o objeto no array com base no id desejado
    const itemIndex = array.findIndex((item) => item.ID === ID)

    if (itemIndex !== -1) {
      // O objeto foi encontrado, faça a edição dos campos
      const updatedItem = {
        ...array[itemIndex],
        SKU_MATCH,
        DESC_MATCH,
        MATCH,
        CODPRODUTO_MATCH,
      }

      // Atualize o objeto no array de produtos
      array[itemIndex] = updatedItem
      console.log(array)

      setProdutos([...array])

      return array
    } else {
      console.log('Não encontrado')
      return array
    }
  }
  const handleEditarComponentes = (item) => {
    // Aqui você pode acessar os valores do item e realizar as operações desejadas
    //alert("Editar componentes do produto:" + item);
    setMatchResultado([])
    limparCampo('completeproduto')

    setShowModalMatch(true)

    const itemEncontrado = produtos.find((items) => items.ID === item)
    setProdutoNota(itemEncontrado?.ID)
    setDescProdutoNota(itemEncontrado?.ID + ' ' + itemEncontrado?.PRODUTO)

    // Outras ações que você deseja realizar ao editar os componentes do produto
  }

  function AddDuplicata(idnfe, documento, vencimento, valor) {
    const dupli = {
      ID: uuidv4(),
      IDNFE: ret?.ID,
      DOCUMENTO: (duplicatas.length + 1).toString().padStart(3, '0'),
      VENCIMENTO: moment().format('YYYY-MM-DD'),
      VALOR: '0',
      OBS: 'S/INF.',
    }

    setDuplicatas([...duplicatas, dupli])
  }

  // useEffect(() => {
  //     listaItensNfe()

  // }, []);

  return (
    <>
      {/* <Navbar /> */}

      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container">
          <a
            className="navbar-brand"
            href="/"
          >
            NFe entrada
          </a>
        </div>
      </nav>

      <div className="container-fluid mt-page">
        <header className="entry-header">
          <section>
            <h1 className="entry-title">{ret.FORNEC_RAZAO}</h1>
            <h4 className="entry-cnpj">CNPJ: {ret.FORNEC_CNPJ}</h4>
          </section>
        </header>

        {/* <Button onClick={toggleModal}>Abrir Modal</Button> */}
        <SidebarModal
          data={formData}
          onSave={handleSave}
          show={showModal}
          onClose={toggleModal}
        />

        <div class="card bg-white my-4 h-100 d-flex ">
          <div class="card-body">
            <div className="card-body bg-light">
              <div className=" p-sm d-flex">
                <h5>Nota fiscal</h5>
              </div>

              <div className="container">
                <div className="row">
                  <div className="col-1">
                    <label htmlFor="id">ID</label>
                    <input
                      type="text"
                      id="id"
                      className="form-control"
                      disabled={true}
                      value={id}
                      onChange={(e) => setId(e.target.value)}
                    />
                  </div>
                  <div className="col-2">
                    <label htmlFor="tipoEntrada">Tipo de Entrada</label>
                    <select
                      id="tipoEntrada"
                      className="form-control"
                      value={tipoEntrada}
                      onChange={(e) => setTipoEntrada(e.target.value)}
                    >
                      <option value="N">Emissão Própria</option>
                      <option value="E">Importação</option>
                      <option value="T">Emitida por Terceiros</option>
                      <option value="X">Importação de XML</option>
                    </select>
                  </div>
                  <div className="col-1">
                    <label htmlFor="serienfe">Serie</label>
                    <input
                      type="text"
                      id="serienfe"
                      className="form-control"
                      value={serieNfe}
                      onChange={(e) => setSerieNfe(e.target.value)}
                    />
                  </div>
                  <div className="col-1">
                    <label htmlFor="numNfe">NFE</label>
                    <input
                      type="text"
                      id="numNfe"
                      className="form-control"
                      value={numNfe}
                      onChange={(e) => setNumNfe(e.target.value)}
                    />
                  </div>
                  <div className="col-5">
                    <label htmlFor="chaveNfe">Chave da NFE</label>
                    <input
                      type="text"
                      id="chaveNfe"
                      className="form-control"
                      disabled={true}
                      value={chaveNfe}
                      onChange={(e) => setChaveNfe(e.target.value)}
                    />
                  </div>
                </div>
              </div>


              <div className="row my-3">
                <div class="col-sm-5">
                  <label htmlFor="naturezaOperacao">Natureza da operação</label>
                  <select
                    id="naturezaOperacao"
                    className="form-control"
                    value={naturezaOperacao}
                    onChange={(e) => setNaturezaOperacao(e.target.value)}
                  >
                    <option value="">
                      -- Selecione a natureza da operação --
                    </option>
                    <option value="1">Compra para revenda</option>
                    <option value="2">Devolução de compra para revenda</option>
                  </select>
                </div>
                <div class="col-sm-3">
                  <label htmlFor="dataEmissao">Data de Emissão</label>
                  <input
                    type="date"
                    id="dataEmissao"
                    className="form-control"
                    disabled="true"
                    value={dataEmissao}
                    onChange={(e) => setDataEmissao(e.target.value)}
                  />
                </div>
                <div class="col-sm-3">
                  <label htmlFor="dataEntrada">Data de Entrada</label>
                  <input
                    type="date"
                    id="dataEntrada"
                    className="form-control"
                    value={dataEntrada}
                    onChange={(e) => setDataEntrada(e.target.value)}
                  />
                </div>
              </div>

              <div className="row my-3">
                <div class="col">
                  <div class="col-sm-5S">
                    <label htmlFor="codigoRegimeTributario">
                      Código Regime Tributário
                    </label>
                    <select
                      id="codigoRegimeTributario"
                      className="form-control"
                      value={codigoRegimeTributario}
                      onChange={(e) =>
                        setCodigoRegimeTributario(e.target.value)
                      }
                    >
                      <option value="">
                        -- Selecione o código do regime tributário --
                      </option>
                      <option value="1">Simples Nacional</option>
                      <option value="2">
                        Simples Nacional - excesso de sublimite de receita bruta
                      </option>
                      <option value="3">Regime Normal</option>
                    </select>
                  </div>
                </div>
                <div class="col">
                  <div class="col-sm-5">
                    <label htmlFor="finalidade">Finalidade</label>
                    <select
                      id="finalidade"
                      className="form-control"
                      value={finalidade}
                      onChange={(e) => setFinalidade(e.target.value)}
                    >
                      <option value="">-- Selecione a finalidade --</option>
                      <option value="1">Normal</option>
                      <option value="2">Complementar</option>
                      <option value="3">Ajuste</option>
                      <option value="4">Devolução/Retorno</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="mb-4 p-sm d-flex">
                <h5>Remetente</h5>
              </div>

              <div className="row my-3">
                <div className="col-sm-6">
                  <label htmlFor="fornecedorRazao">Contato do fornecedor</label>

                  <AutocompleteCliente
                    placeholder="Pesquisar fornecedores..."
                    onClickId={setIdCliente}
                    onClickNome={setNomeCliente}
                    value={nome_cliente}
                  />
                </div>

                <div className="col-sm-4">
                  <label htmlFor="fornecedorTipo">Tipo do Fornecedor</label>
                  <select
                    id="fornecedorTipo"
                    className="form-control"
                    value={fornecedorTipo}
                    onChange={(e) => setFornecedorTipo(e.target.value)}
                  >
                    <option value="">
                      -- Selecione o tipo do fornecedor --
                    </option>
                    <option value="Fisíca">Pessoa Física</option>
                    <option value="Jurídico">Pessoa Jurídica</option>
                    <option value="3">Outro</option>
                  </select>
                </div>
              </div>

              <div className="row my-3">
                <div className="col-sm-8">
                  <label htmlFor="fornecedorEndereco">
                    Endereço do Fornecedor
                  </label>
                  <input
                    type="text"
                    id="fornecedorEndereco"
                    className="form-control"
                    value={fornecedorEndereco}
                    onChange={(e) => setFornecedorEndereco(e.target.value)}
                  />
                </div>
                <div className="col-sm-2">
                  <label htmlFor="fornecedorNumero">Número</label>
                  <input
                    type="text"
                    id="fornecedorNumero"
                    className="form-control"
                    value={fornecedorNumero}
                    onChange={(e) => setFornecedorNumero(e.target.value)}
                  />
                </div>
              </div>

              <div className="row my-3">
                <div className="col-sm-4">
                  <label htmlFor="fornecedorBairro">Bairro</label>
                  <input
                    type="text"
                    id="fornecedorBairro"
                    className="form-control"
                    value={fornecedorBairro}
                    onChange={(e) => setFornecedorBairro(e.target.value)}
                  />
                </div>
                <div className="col-sm-4">
                  <label htmlFor="fornecedorCidade">Cidade</label>
                  <input
                    type="text"
                    id="fornecedorCidade"
                    className="form-control"
                    value={fornecedorCidade}
                    onChange={(e) => setFornecedorCidade(e.target.value)}
                  />
                </div>
                <div className="col-sm-2">
                  <label htmlFor="fornecedorUf">UF</label>
                  <input
                    type="text"
                    id="fornecedorUf"
                    className="form-control"
                    value={fornecedorUf}
                    onChange={(e) => setFornecedorUf(e.target.value)}
                  />
                </div>
              </div>

              <div className="row my-3">
                <div className="col-sm-2">
                  <label htmlFor="fornecedorCep">CEP</label>
                  <InputMask
                    type="text"
                    onBlur={buscaCep}
                    mask="99999-999"
                    id="fornecedorCep"
                    className="form-control"
                    value={fornecedorCep}
                    onChange={(e) => setFornecedorCep(e.target.value)}
                  />
                </div>
                <div className="col-sm-2">
                  <label htmlFor="fornecedorIbge">Código IBGE</label>
                  <input
                    type="text"
                    id="fornecedorIbge"
                    className="form-control"
                    value={fornecedorIbge}
                    onChange={(e) => setFornecedorIbge(e.target.value)}
                  />
                </div>
              </div>

              <div className=" p-sm d-flex">
                <h5>Itens da nota fiscal </h5>
              </div>
              <div className="table-responsive">
                <table
                  className="table table-bordered  custom-table responsive"
                  style={{ backgroundColor: 'white', fontSize: '0.8rem' }} // Ajuste o valor de fontSize conforme necessário
                >
                  <thead className="bg-primary text-white">
                    <tr>
                      <th
                        scope="col"
                        style={{ width: '100px' }}
                      >
                        Cod.
                      </th>
                      <th
                        scope="col"
                        style={{ width: '200px' }}
                      >
                        Ean
                      </th>
                      <th
                        scope="col"
                        className="col-lg-6"
                      >
                        Descrição
                      </th>
                      <th
                        scope="col"
                        className="col-sm"
                      >
                        Codigo
                      </th>
                      <th scope="col">NCM</th>
                      <th
                        scope="col"
                        className="col-sm-2"
                      >
                        Qtde.
                      </th>
                      <th scope="col">Un</th>
                      <th
                        scope="col"
                        className="col-sm-10"
                      >
                        Preco Un.
                      </th>
                      <th scope="col">Custo Un.</th>

                      <th scope="col">Valor Total.</th>
                      <th
                        scope="col"
                        className="col-lg-6"
                      >
                        Ações.
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: '0.8rem' }}>
                    {produtos
                      // .sort((a, b) => new Date(b.data) - new Date(a.data)) // Ordena a lista pela data decrescente
                      .map((items, index) => {
                        const handleQuantidadeChange = (index, event) => {
                          const newProdutos = [...produtos]
                          newProdutos[index].QUANTIDADE = event.target.value
                          newProdutos[index].VALORTOTAL =
                            newProdutos[index].QUANTIDADE *
                            newProdutos[index].VALOR
                          setProdutos(newProdutos)
                        }

                        const handlePrecoUnitarioChange = (index, event) => {
                          const newProdutos = [...produtos]
                          newProdutos[index].VALOR = event.target.value
                          newProdutos[index].VALORTOTAL =
                            newProdutos[index].QUANTIDADE *
                            newProdutos[index].VALOR
                          setProdutos(newProdutos)
                        }

                        const formatter = new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })

                        return (
                          <tr key={items.CODIGOPRODUTO}>
                            <td>{items.CODIGOPRODUTO}</td>
                            <td>{items.EAN}</td>
                            <td>{items.PRODUTO}</td>
                            <td
                              title={
                                items.SKU_MATCH ? ` ${items.DESC_MATCH}` : ''
                              }
                            >
                              {items.SKU_MATCH || (
                                <span className="badge bg-success py-2 px-3 rounded-pill">
                                  Produto Novo?
                                </span>
                              )}
                            </td>

                            <td>{items.NCM}</td>
                            <td>
                              <input
                                type="text"
                                value={items.QUANTIDADE}
                                onChange={(event) => handleQuantidadeChange(index, event)}
                                className="form-control"
                                style={{ width: "100px" }} // Define o tamanho para 100px
                              />
                            </td>
                            <td>{items.MEDIDA}</td>
                            <td>
                              <input
                                type="number"
                                step="0.01"
                                value={items.VALOR}
                                onChange={(event) =>
                                  handlePrecoUnitarioChange(index, event)
                                }
                                className="form-control"
                                style={{ width: "100px" }} // Define o tamanho para 100px
                              />
                            </td>
                            <td>{formatter.format(items.CUSTO)}</td>
                            <td>{formatter.format(items.VALORTOTAL)}</td>
                            <td>
                              <div className="d-flex">
                                <button
                                  className="btn btn-outline-primary mr-2"
                                  title="Atualizar ou criar produtos a partir da nota"
                                  onClick={() =>
                                    handleEditarComponentes(items.ID)
                                  }
                                >
                                  <span className="bi bi-link"></span>
                                </button>

                                <button
                                  className="btn btn-outline-primary mr-2"
                                  title="Estoque"
                                  onClick={() =>
                                    handleEditarComponentes(items.ID)
                                  }
                                >
                                  <i className="bi bi-box-seam"></i>
                                </button>

                                <button
                                  className="btn btn-outline-primary mr-2"
                                  title="Editar componentes do produto"
                                >
                                  <i className="bi bi-pencil"></i>
                                </button>

                                <button
                                  className="btn btn-outline-danger"
                                  title="Excluir"
                                >
                                  <i className="bi bi-trash text-danger"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>
              {produtos.length == 0 ? (
                <div className="no-item">sem movimentações</div>
              ) : null}

              <div className="col-sm-2 mt-4 mb-4">
                <button className="btn btn-primary" onClick={calcularCustos}>Calcular Custos</button>
              </div>

              <div className="mb-4 p-sm d-flex">
                <h5>Totais</h5>
              </div>



              <form>
                <div className="row my-3">
                  <div className="col-sm-3">
                    <label htmlFor="totalProdutos">Total de Produtos</label>
                    <input
                      type="text"
                      id="totalProdutos"
                      className="form-control"
                      value={totalProdutos}
                      onChange={(e) => setTotalProdutos(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="total">Total:</label>
                    <input
                      type="text"
                      id="total"
                      value={total}
                      className="form-control"
                      onChange={(e) => setTotal(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="acrescimo">Acréscimo:</label>
                    <input
                      type="text"
                      id="acrescimo"
                      value={acrescimo}
                      className="form-control"
                      onChange={(e) => setAcrescimo(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="desconto">Desconto:</label>
                    <input
                      type="text"
                      id="desconto"
                      className="form-control"
                      value={desconto}
                      onChange={(e) => setDesconto(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="frete">Frete:</label>
                    <input
                      type="text"
                      id="frete"
                      className="form-control"
                      value={frete}
                      onChange={(e) => setFrete(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="icmsFrete">ICMS do Frete:</label>
                    <input
                      type="text"
                      id="icmsFrete"
                      className="form-control"
                      value={icmsFrete}
                      onChange={(e) => setIcmsFrete(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="outrasdespesas">Outras despesas:</label>
                    <div className="input-group">
                      <input
                        type="text"
                        id="outrasdespesas"
                        className="form-control"
                        value={outrasdespesas}
                        onChange={(e) => {
                          const value = e.target.value;
                          setOutrasDespesas(value);
                          // Desativa o botão se o valor for nulo ou inválido
                          if (!value || isNaN(parseFloat(value))) {
                            document.getElementById('btn-calcular').disabled = true;
                          } else {
                            document.getElementById('btn-calcular').disabled = false;
                          }
                        }}
                      />
                      <button
                        id="btn-calcular"
                        className="btn btn-primary"
                        type="button"
                        disabled={!outrasdespesas || isNaN(parseFloat(outrasdespesas))}
                        onClick={() => calcularCusto(outrasdespesas)}
                      >
                        Calcular
                      </button>
                    </div>
                  </div>


                </div>
              </form>

              <div className="mb-4 p-sm d-flex">
                <h5>Impostos</h5>
              </div>

              <form>
                <div className="row my-3">
                  <div className="col-sm-3">
                    <label htmlFor="vlrBaseIcmsSt">Valor Base do ICMS ST</label>
                    <input
                      type="text"
                      id="vlrBaseIcmsSt"
                      className="form-control"
                      value={vlrBaseIcmsSt}
                      onChange={(e) => setVlrBaseIcmsSt(e.target.value)}
                    />
                  </div>

                  {/* <div className="col-sm-3">
                                        <label htmlFor="vlrIcmsSt">Valor do ICMS ST</label>
                                        <input type="text" id="vlrIcmsSt" className="form-control" value={vlrIcmsSt} onChange={(e) => setVlrIcmsSt(e.target.value)} />
                                    </div> */}

                  <div className="col-sm-3">
                    <label htmlFor="codificacaoFiscal">
                      Codificação Fiscal
                    </label>
                    <input
                      type="text"
                      id="codificacaoFiscal"
                      className="form-control"
                      value={codificacaoFiscal}
                      onChange={(e) => setCodificacaoFiscal(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="emissorCodigoEstado">
                      Código do Estado do Emissor
                    </label>
                    <input
                      type="text"
                      id="emissorCodigoEstado"
                      className="form-control"
                      value={emissorCodigoEstado}
                      onChange={(e) => setEmissorCodigoEstado(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="chaveNfe">Chave da NFE</label>
                    <input
                      type="text"
                      id="chaveNfe"
                      className="form-control"
                      value={chaveNfe}
                      onChange={(e) => setChaveNfe(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="bcIcms">Base de Cálculo do ICMS</label>
                    <input
                      type="text"
                      id="bcIcms"
                      className="form-control"
                      value={bcIcms}
                      onChange={(e) => setBcIcms(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="valorIcms">Valor do ICMS</label>
                    <input
                      type="text"
                      id="valorIcms"
                      className="form-control"
                      value={valorIcms}
                      onChange={(e) => setValorIcms(e.target.value)}
                    />
                  </div>
                </div>
              </form>

              <form>
                <div className="row my-3">
                  <div className="col-sm-3">
                    <label htmlFor="valorPis">Valor do PIS</label>
                    <input
                      type="text"
                      id="valorPis"
                      className="form-control"
                      value={valorPis}
                      onChange={(e) => setValorPis(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="valorCofins">Valor do COFINS</label>
                    <input
                      type="text"
                      id="valorCofins"
                      className="form-control"
                      value={valorCofins}
                      onChange={(e) => setValorCofins(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="valorIpi">Valor do IPI</label>
                    <input
                      type="text"
                      id="valorIpi"
                      className="form-control"
                      value={valorIpi}
                      onChange={(e) => setValorIpi(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="valorSeguro">Valor do Seguro</label>
                    <input
                      type="text"
                      id="valorSeguro"
                      className="form-control"
                      value={valorSeguro}
                      onChange={(e) => setValorSeguro(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row my-3w">
                  <div className="col-sm-3">
                    <label htmlFor="freteIncluso">Frete Incluso</label>
                    <input
                      type="text"
                      id="freteIncluso"
                      className="form-control"
                      value={freteIncluso}
                      onChange={(e) => setFreteIncluso(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="valorIcmsSubIncluso">
                      Valor do ICMS Substituto Incluso
                    </label>
                    <input
                      type="text"
                      id="valorIcmsSubIncluso"
                      className="form-control"
                      value={valorIcmsSubIncluso}
                      onChange={(e) => setValorIcmsSubIncluso(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="custoSemDesconto">Custo sem Desconto</label>
                    <input
                      type="text"
                      id="custoSemDesconto"
                      className="form-control"
                      value={custoSemDesconto}
                      onChange={(e) => setVlrBaseIcmsSt(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="vlrIcmsSt">Valor do ICMS ST</label>
                    <input
                      type="text"
                      id="vlrIcmsSt"
                      className="form-control"
                      value={vlrIcmsSt}
                      onChange={(e) => setVlrIcmsSt(e.target.value)}
                    />
                  </div>
                </div>
              </form>
              <form>
                <div className="row my-3">
                  <div className="form-group col-sm-3">
                    <label htmlFor="totalProdutos">Total de Produtos</label>
                    <input
                      type="text"
                      id="totalProdutos"
                      className="form-control"
                      value={totalProdutos}
                      onChange={(e) => setTotalProdutos(e.target.value)}
                    />
                  </div>

                  <div className="form-group col-sm-3">
                    <label htmlFor="codificacaoFiscal">
                      Codificação Fiscal
                    </label>
                    <input
                      type="text"
                      id="codificacaoFiscal"
                      className="form-control"
                      value={codificacaoFiscal}
                      onChange={(e) => setCodificacaoFiscal(e.target.value)}
                    />
                  </div>

                  <div className="form-group col-sm-3">
                    <label htmlFor="emissorCodigoEstado">
                      Código do Estado do Emissor
                    </label>
                    <input
                      type="text"
                      id="emissorCodigoEstado"
                      className="form-control"
                      value={emissorCodigoEstado}
                      onChange={(e) => setEmissorCodigoEstado(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row my-3">
                  <div className="form-group col-sm-3">
                    <label htmlFor="bcIcms">Base de Cálculo do ICMS</label>
                    <input
                      type="text"
                      id="bcIcms"
                      className="form-control"
                      value={bcIcms}
                      onChange={(e) => setBcIcms(e.target.value)}
                    />
                  </div>

                  <div className="form-group col-sm-3">
                    <label htmlFor="valorIcms">Valor do ICMS</label>
                    <input
                      type="text"
                      id="valorIcms"
                      className="form-control"
                      value={valorIcms}
                      onChange={(e) => setValorIcms(e.target.value)}
                    />
                  </div>

                  <div className="form-group col-sm-3">
                    <label htmlFor="valorPis">Valor do PIS</label>
                    <input
                      type="text"
                      id="valorPis"
                      className="form-control"
                      value={valorPis}
                      onChange={(e) => setValorPis(e.target.value)}
                    />
                  </div>

                  <div className="form-group col-sm-3">
                    <label htmlFor="valorCofins">Valor do COFINS</label>
                    <input
                      type="text"
                      id="valorCofins"
                      className="form-control"
                      value={valorCofins}
                      onChange={(e) => setValorCofins(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row my-3">
                  <div className="col-sm-3">
                    <label htmlFor="valorSeguro">Valor do Seguro</label>
                    <input
                      type="text"
                      id="valorSeguro"
                      className="form-control"
                      value={valorSeguro}
                      onChange={(e) => setValorSeguro(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="freteIncluso">Frete Incluso</label>
                    <input
                      type="text"
                      id="freteIncluso"
                      className="form-control"
                      value={freteIncluso}
                      onChange={(e) => setFreteIncluso(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="valorIcmsSubIncluso">
                      Valor do ICMS Substituto Incluso
                    </label>
                    <input
                      type="text"
                      id="valorIcmsSubIncluso"
                      className="form-control"
                      value={valorIcmsSubIncluso}
                      onChange={(e) => setValorIcmsSubIncluso(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="custoSemDesconto">Custo sem Desconto</label>
                    <input
                      type="text"
                      id="custoSemDesconto"
                      className="form-control"
                      value={custoSemDesconto}
                      onChange={(e) => setCustoSemDesconto(e.target.value)}
                    />
                  </div>
                </div>
              </form>

              <div className="mb-4 p-sm d-flex">
                <h5>Volume</h5>
              </div>

              <form onSubmit={handleSubmit}>
                <Row className="my-3">
                  <Col sm={3}>
                    <label htmlFor="quantidade">Quantidade:</label>
                    <input
                      type="number"
                      id="quantidade"
                      className="form-control"
                      value={quantidade}
                      onChange={(event) => setQuantidade(event.target.value)}
                    />
                  </Col>
                  <Col sm={3}>
                    <label htmlFor="pesoBruto">Peso Bruto:</label>
                    <input
                      type="text"
                      id="pesoBruto"
                      className="form-control"
                      value={pesoBruto}
                      onChange={(event) => setPesoBruto(event.target.value)}
                    />
                  </Col>
                  <Col sm={3}>
                    <label htmlFor="pesoLiquido">Peso Líquido:</label>
                    <input
                      type="text"
                      id="pesoLiquido"
                      className="form-control"
                      value={pesoLiquido}
                      onChange={(event) => setPesoLiquido(event.target.value)}
                    />
                  </Col>

                  <Col sm={3}>
                    <label htmlFor="numeracao">Numeração do volume:</label>
                    <input
                      type="text"
                      id="numeracao"
                      className="form-control"
                      value={numeracao}
                      onChange={(event) => setNumeracao(event.target.value)}
                    />
                  </Col>
                </Row>

                <Row className="my-3">
                  <Col sm={6}>
                    <label htmlFor="especie">Espécie:</label>
                    <input
                      type="text"
                      id="especie"
                      className="form-control"
                      value={especie}
                      onChange={(event) => setEspecie(event.target.value)}
                    />
                  </Col>
                  <Col sm={6}>
                    <label htmlFor="marca">Marca:</label>
                    <input
                      type="text"
                      id="marca"
                      className="form-control"
                      value={marca}
                      onChange={(event) => setMarca(event.target.value)}
                    />
                  </Col>
                </Row>
              </form>

              <div className="mb-4 p-sm d-flex">
                <h5>Transportador</h5>
              </div>

              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <label htmlFor="transportadoraNome">
                      Nome da Transportadora
                    </label>
                    <input
                      type="text"
                      id="transportadoraNome"
                      className="form-control"
                      value={transportadoraNome}
                      onChange={(e) => setTransportadoraNome(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="transportadoraCnpj">
                      CNPJ da Transportadora
                    </label>
                    <InputMask
                      type="text"
                      id="transportadoraCnpj"
                      mask="99.999.999/9999-99"
                      className="form-control"
                      value={transportadoraCnpj}
                      onChange={(e) => setTransportadoraCnpj(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <label htmlFor="transportadoraEndereco">Endereço</label>
                    <input
                      type="text"
                      id="transportadoraEndereco"
                      className="form-control"
                      value={transportadoraEndereco}
                      onChange={(e) =>
                        setTransportadoraEndereco(e.target.value)
                      }
                    />
                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="transportadoraInsc">Inscrição</label>
                    <input
                      type="text"
                      id="transportadoraInsc"
                      className="form-control"
                      value={transportadoraInsc}
                      onChange={(e) => setTransportadoraInsc(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <label htmlFor="transportadoraCidade">Cidade</label>
                    <input
                      type="text"
                      id="transportadoraCidade"
                      className="form-control"
                      value={transportadoraCidade}
                      onChange={(e) => setTransportadoraCidade(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <div className="row">
                      <label htmlFor="transportadoraPlaca">
                        Placa do Veículo
                      </label>

                      <div className="col-sm-6">
                        <input
                          type="text"
                          id="transportadoraPlaca"
                          className="form-control"
                          value={transportadoraPlaca}
                          onChange={(e) =>
                            setTransportadoraPlaca(e.target.value)
                          }
                        />
                      </div>
                      {/* <div className="col-sm-6">
                                                <label htmlFor="transportadoraUfPlaca">UF da Placa</label>
                                                <input type="text" id="transportadoraUfPlaca" className="form-control" value={transportadoraUfPlaca} onChange={(e) => setTransportadoraUfPlaca(e.target.value)} />
                                            </div> */}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-3">
                    <label htmlFor="transportadoraUf">UF</label>
                    <input
                      type="text"
                      id="transportadoraUf"
                      className="form-control"
                      value={transportadoraUf}
                      onChange={(e) => setTransportadoraUf(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label htmlFor="transportadoraTipo">Tipo</label>
                    <input
                      type="text"
                      id="transportadoraTipo"
                      className="form-control"
                      value={transportadoraTipo}
                      onChange={(e) => setTransportadoraTipo(e.target.value)}
                    />
                  </div>
                </div>
              </form>

              <label htmlFor="status">Status</label>
              <input
                type="text"
                id="status"
                className="form-control"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              />

              <label htmlFor="entradaTipo">Tipo de Entrada</label>
              <input
                type="text"
                id="entradaTipo"
                className="form-control"
                value={entradaTipo}
                onChange={(e) => setEntradaTipo(e.target.value)}
              />

              <div className="mb-4 p-sm d-flex">
                <h5>Pagamentos</h5>
              </div>

              <div className="col-12">
                <table className="table bg-light">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="text-dark"
                      >
                        Dias
                      </th>
                      <th
                        scope="col"
                        className="text-dark"
                      >
                        Documento
                      </th>
                      <th
                        scope="col"
                        className="text-dark"
                      >
                        Valor
                      </th>
                      <th
                        scope="col"
                        className="text-dark"
                      >
                        Vencimento
                      </th>
                      <th
                        scope="col"
                        className="text-dark"
                      >
                        Obs
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {duplicatas.map((dupli, index) => {
                      const dataEntrada = moment(dataEmissao)
                      const vencimento = moment(dupli.VENCIMENTO)
                      const dias = dataEntrada.diff(vencimento, 'days') * -1
                      return (
                        <tr key={dupli.ID}>
                          <td>
                            <input
                              type="text"
                              value={dias}
                              className="form-control"
                              disabled
                            />
                          </td>
                          {/* Outros campos */}
                          <td>
                            <input
                              type="text"
                              value={dupli.DOCUMENTO}
                              className="form-control"
                              disabled
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={dupli.VALOR}
                              step="0.01"
                              className="form-control"
                              onChange={(e) =>
                                handleValorChange(e.target.value, index)
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="date"
                              value={vencimento.format('YYYY-MM-DD')}
                              className="form-control"
                              onChange={(e) =>
                                handleVencimentoChange(e.target.value, index)
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="text"
                              value={dupli.OBS}
                              onChange={(e) => updateArray(e, index)}
                            />
                          </td>

                          <td>
                            <button
                              type="button"
                              onClick={() => excluirDuplicata(dupli.ID)}
                              className="btn btn-danger"
                            >
                              <i className="bi bi-trash3-fill"></i>
                            </button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>

                {duplicatas.length == 0 ? (
                  <div className="no-item">Sem duplicatas</div>
                ) : null}

                <div style={{ marginBottom: '100px' }}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={AddDuplicata}
                  >
                    Adicionar
                  </button>
                </div>

              </div>
            </div>
          </div>

          <nav className="navbar fixed-bottom fixed-end bg-body-tertiary navbar-transparent mt-100">
            <div className="container-fluid ">
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-primary me-3"
                  onClick={SalvarDados}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <>
                      <i className="bi bi-save"></i> Salvar
                    </>
                  )}
                </button>
                <button
                  className="btn btn-secondary me-3"
                  onClick={handleClose}
                >
                  <i className="bi bi-x"></i> Cancelar
                </button>
                <div className="form-group">
                  <label htmlFor="lancarContas">Lançar contas:</label>
                  <select
                    id="lancarContas"
                    className="form-select ms-3"
                    value={addCont}
                    onChange={(event) => {
                      const selectedValue = event.target.value;
                      setAddCont(selectedValue);
                      console.log(selectedValue);
                    }}
                  >
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
              </div>
            </div>
          </nav>


        </div>



        {/* Modal de Match */}
        <Modal
          show={showModalMatch}
          onHide={() => setShowModalMatch(false)}
          size="lg"
          centered
          dialogClassName="modal-match"
        >
          <Draggable handle=".modal-drag-handle">
            <div>
              <Modal.Header
                closeButton
                className="modal-drag-handle"
              >
                <Modal.Title>Match de Produto</Modal.Title>
                <ArrowBarRight className="ml-auto" />
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group>
                    <Form.Label>Produto da Nota de Entrada</Form.Label>
                    <Form.Control
                      type="text"
                      value={descprodutonota}
                      onChange={(e) => setDescProdutoNota(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Item do Banco de Dados</Form.Label>

                    <AutocompleteProdutoMatch
                      placeholder="Produto banco..."
                      onClickId={setIdProdutoMatch}
                      onClickNome={setMatchProduto}
                      onClickProdInterno={setCodigoInterno}
                      OnClickValor={setClickValor}
                      ClickTexto={setTextoClick}
                      value={matchproduto}
                    />
                  </Form.Group>
                </Form>
                {matchResultado && (
                  <Table
                    striped
                    bordered
                  >
                    <thead>
                      <tr>
                        <th>Produto</th>
                        <th>Item Banco</th>
                        <th>Match</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{matchResultado.produto}</td>
                        <td>{matchResultado.itemBanco}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            {matchResultado.match ? (
                              <CheckCircleFill className="text-success mr-2 animated bounceIn" />
                            ) : (
                              <XCircleFill className="text-danger mr-2 animated shake" />
                            )}
                            <span className="match-message">
                              {matchResultado.match
                                ? 'Produto correspondente'
                                : 'Produto não corresponde'}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowModalMatch(false)}
                >
                  <XCircleFill className="mr-2" />
                  Fechar
                </Button>
                <Button
                  variant="primary"
                  onClick={(e) => {
                    e.preventDefault(); // Impede a submissão padrão do formulário
                    handleMatchSubmit();
                  }}
                >
                  <CheckCircleFill className="mr-2" />
                  Match
                </Button>

              </Modal.Footer>
            </div>
          </Draggable>
        </Modal>
      </div>



      {/*  <Modal
        show={showPopup}
        onHide={handleClosePopup}
      >
        <Modal.Header closeButton>
          <Modal.Title>Contas já lançadas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>As contas já foram lançadas.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClosePopup}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal> */}

      <Modal
        show={showConfirmation}
        onHide={() => setShowConfirmation(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>Tem certeza que deseja excluir a duplicata?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmation(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={confirmarExclusaoDuplicata}
          >
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>


    </>
  )
}

export default NfeEntrada
